import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL || 'https://api.insightpane.test'

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true, // Important for Sanctum CSRF cookies
})

/**
 * Get CSRF token from cookie
 */
function getCsrfToken(): string | null {
  if (typeof document === 'undefined') {
    return null
  }

  try {
    const token = document.cookie
      .split('; ')
      .find((row) => row.startsWith('XSRF-TOKEN='))
      ?.split('=')[1]
    
    return token ? decodeURIComponent(token) : null
  } catch (error) {
    console.warn('Failed to retrieve CSRF token from cookies:', error)
    return null
  }
}

// Request interceptor to add CSRF token
api.interceptors.request.use((config) => {
  // Add CSRF token to header (read from cookie)
  const csrfToken = getCsrfToken()
  if (csrfToken) {
    config.headers['X-XSRF-TOKEN'] = csrfToken
  }

  return config
})

// Handle 401 responses by clearing session data and redirecting to login
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('user')
      localStorage.removeItem('workspace')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default api
